export const ArxEditorURL = "https://editor.arxtect.com";
